import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';

export default function InvoiceOriginalViewer({storagePath,bucket='invoices',t,defaultOpen=false}){
if(!storagePath)return null;
const[open,setOpen]=useState(defaultOpen);
const[url,setUrl]=useState(null);
const[loading,setLoading]=useState(false);
const[error,setError]=useState(false);

const ext=(storagePath.split('.').pop()||'').toLowerCase();
const isPdf=ext==='pdf';
const isImage=['jpg','jpeg','png','webp','gif'].includes(ext);
const isHeic=['heic','heif'].includes(ext);

// Reset when storagePath changes (queue advancing to a different invoice)
useEffect(()=>{
  setUrl(null);setError(false);
},[storagePath]);

useEffect(()=>{
  if(!open||url)return;
  setLoading(true);
  supabase.storage.from(bucket).createSignedUrl(storagePath,3600).then(({data,error:err})=>{
    if(err||!data?.signedUrl){setError(true);setLoading(false);return;}
    setUrl(data.signedUrl);setLoading(false);
  }).catch(()=>{setError(true);setLoading(false);});
},[open,storagePath]);

return(
<div style={{border:`1px solid ${t.bd}`,borderRadius:8,background:t.sf,marginBottom:16,overflow:'hidden'}}>
<button onClick={()=>setOpen(p=>!p)} style={{display:'flex',alignItems:'center',width:'100%',padding:'10px 16px',background:'transparent',border:'none',cursor:'pointer',fontFamily:"'DM Sans',sans-serif"}}>
<span style={{fontSize:13,fontWeight:600,color:t.bl}}>{open?'📄 Hide Original Invoice':'📄 View Original Invoice'}</span>
</button>
{open&&<div style={{padding:'0 16px 12px'}}>
{loading?<div style={{fontSize:11,color:t.td,padding:12,textAlign:'center'}}>Loading preview...</div>:
error?<div style={{fontSize:11,color:t.td,padding:12,textAlign:'center'}}>Preview unavailable.{url&&<> <a href={url} target="_blank" rel="noopener noreferrer" style={{color:t.bl,textDecoration:'underline'}}>Download original</a></>}</div>:
url&&<>
{isPdf&&<iframe src={url+'#toolbar=1&navpanes=0&view=FitH'} style={{width:'100%',height:600,border:'none',borderRadius:6}}/>}
{isImage&&<img src={url} style={{maxWidth:'100%',maxHeight:600,display:'block',borderRadius:6}} alt="Invoice original"/>}
{isHeic&&<div style={{fontSize:11,color:t.td,padding:12}}>HEIC files can't be previewed in the browser. The original was processed for extraction. <a href={url} target="_blank" rel="noopener noreferrer" style={{color:t.bl,textDecoration:'underline'}}>Download original</a></div>}
{!isPdf&&!isImage&&!isHeic&&<><iframe src={url} style={{width:'100%',height:600,border:'none',borderRadius:6}}/><div style={{fontSize:9,color:t.td,marginTop:4}}>Preview may not work for this file type. <a href={url} target="_blank" rel="noopener noreferrer" style={{color:t.bl,textDecoration:'underline'}}>Download original</a></div></>}
</>}
</div>}
</div>);
}
